// export const baseUrl = "http://localhost:3000";

let config = {
	baseUrl: `https://backend.salento-immobiliare.myservers.app`,
};
export default config;
